// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1ldVC","row":"styles_row__3Tzya"};